import React from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from '../store';

export default function FeatureGate({ feature, children, fallback }) {
  const navigate = useNavigate();
  const subscription = useStore((s) => s.subscription);
  const isPremium = useStore((s) => s.isPremium);

  const hasFeature = isPremium() && subscription?.features?.[feature];

  if (hasFeature) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  return (
    <div className="relative">
      <div className="opacity-40 pointer-events-none blur-[2px]">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <button
          onClick={() => navigate(`/premium?source=${feature}`)}
          className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium rounded-xl shadow-lg transition-colors"
        >
          Unlock with Premium
        </button>
      </div>
    </div>
  );
}
